export default __webpack_public_path__ + "static/media/31_2_2.6ee686d3.png";